import React, { useEffect, useContext } from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import { useNavbar } from '../hooks/useNavbar';
import { usePaths } from '../hooks/usePaths';
import { ViewportContext } from '../contexts/viewport';

import ConvelioLogo from './ConvelioLogo';
import Buttons from './Buttons';
import Button from './Button';
import Navlink from './Navlink';

const Navbar = ({ navbar }) => {
  const { links = [], buttons = [] } = navbar;
  const { currentPath } = usePaths();
  const {
    scroll,
    isNavbarTransparent,
    setActiveNavlinks,
    isBurgerMenu,
    onClickBurger
  } = useNavbar();
  const { isSmallScreen, isTablet } = useContext(ViewportContext);

  useEffect(() => {
    setActiveNavlinks(links);
  }, [links, currentPath]);

  const isNavbarDark = isNavbarTransparent && !scroll && !isBurgerMenu;

  const getNavbarButtonsVersion = () =>
    isNavbarDark ? 'secondary-text' : 'tertiary-text';

  const getTabletStyle = () => (isTablet && !isSmallScreen ? '--x-small' : '');

  const loginButton = isTablet
    ? {
        ...buttons[0],
        label: <Trans id="buttonLabelLogin" />,
        icon: null
      }
    : buttons[0];
  const getAQuoteButton = isTablet
    ? {
        ...buttons[1],
        label: <Trans id="buttonLabelInstantQuote" />,
        icon: null
      }
    : buttons[1];

  const convelioLogoColor = isNavbarDark ? 'white' : 'black';

  const style = `navbar ${scroll ? '--scroll' : ''} ${
    isBurgerMenu ? '--burger' : ''
  } ${isNavbarTransparent && !scroll && !isBurgerMenu ? '--transparent' : ''}`;

  return (
    <>
      <nav
        id="navbar"
        className={style}
        role="banner"
        itemScope
        itemType="http://schema.org/WPHeader"
        data-module="menu"
      >
        <div className="navbar__container wrapper">
          <ConvelioLogo color={convelioLogoColor} />
          <ul className="navbar__links">
            {links?.map((navlink) => (
              <Navlink
                key={navlink.id}
                navlink={{
                  ...navlink,
                  version: getNavbarButtonsVersion(),
                  additionalClassNames: `--light ${getTabletStyle()}`
                }}
              />
            ))}
          </ul>
          <Buttons
            identifier="navbar"
            buttons={[
              {
                ...loginButton,
                version: getNavbarButtonsVersion(),
                additionalClassNames: getTabletStyle()
              },
              {
                ...getAQuoteButton,
                additionalClassNames: getTabletStyle()
              }
            ]}
          />

          {isSmallScreen && (
            <Button
              button={{
                icon: isBurgerMenu ? 'MdClose' : 'MdMenu',
                version: 'wrapper',
                ariaLabel: 'Burger button'
              }}
              onClick={onClickBurger}
            />
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
